import React from 'react';
import { ClipSuggestionContextType } from './types';

const ClipSuggestionContext = React.createContext<
  ClipSuggestionContextType | undefined
>(undefined);

export default ClipSuggestionContext;
